<template>
    <div>
        <div class="modal micromodal-slide" id="contact-list-modal" aria-hidden="true" v-if="is_admin">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-new-external-contact-title">
                    <div class="modal__content" id="modal-new-external-contact-content">
                        <h3>{{ title }}</h3>
                        <div class="form__group">
                            <label class="form__label" for="name">List name</label>
                            <input type="text" name="name" class="form__control" v-model="contactList.name">
                        </div>

                        <h5>Custom fields for contacts in this list</h5>
                        <div class="fields">
                            <div v-for="(field, i) in contactList.fields">
                                <div class="grid justify-space-between">
                                    <div class="col-auto align-self-start">
                                        <label class="form__label">Field label</label>
                                        <input type="text" v-model="field.label" class="form__control"/>
                                    </div>
                                    <div class="col-auto align-self-start">
                                        <label class="form__label">Field type</label>
                                        <select v-model="field.type" class="form__control">
                                            <option value="text">Text</option>
                                            <option value="link">Link</option>
                                            <option value="email">Email</option>
                                            <option value="tel">Telephone</option>
                                            <option value="yes_no">Yes/No</option>
                                        </select>
                                    </div>
                                    <div class="col-2 align-self-center">
                                        <button class="btn btn-tiny btn-danger" v-on:click.stop.prevent="deleteContactListField(i)">
                                            <i class="icon ion-md-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button class="btn btn-tiny" v-on:click.stop.prevent="addContactListField()">Add a field</button>

                    </div>
                    <footer class="modal__footer">
                        <button class="btn btn-danger" v-if="contactList.id" v-on:click.stop.prevent="confirmDeleteList()">
                            <i class="icon ion-md-trash"></i>
                        </button>
                        <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                        <button class="btn btn-primary"  v-on:click.stop.prevent="addEditContactList(contactList.id)">{{ title }}</button>
                    </footer>
                </div>
            </div>
        </div>
        <div class="modal micromodal-slide" id="delete-list" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-post-settings-title">
                    <div class="modal__content" id="modal-new-category-content">
                        <h3>Delete contact list "{{ contactList.name }}"</h3>
                        <p>Are you sure you wish to delete "{{ contactList.name }}"?</p>
                    </div>
                    <footer class="modal__footer">
                        <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                        <button class="btn btn-danger" v-on:click.stop.prevent="deleteContactList(contactList.id)">Delete</button>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MicroModal from 'micromodal';

    export default {
        props: {
            contactList : {
                default: {
                    name: "",
                    fields: []
                }
            }
        },
        data() {
            return {
                is_admin: window.user_can.admin,
            }
        },
        computed: {
            title: function(){
                if( typeof this.contactList.id !== "undefined"){
                    return "Edit contact list";
                }else{
                    return "Create contact list";
                }
            }
        },
        methods: {
            deleteContactListField(key){
                this.contactList.fields.splice(key, 1);
            },
            addContactListField(){
                this.contactList.fields.push({
                    'label' : "",
                    'type' : "text"
                });
            },
            addEditContactList(listID) {
                if(typeof listID === "undefined"){
                    axios.post('/api/people/contact-list', this.contactList).then((response) => {
                        MicroModal.close("contact-list-modal");
                        this.$store.dispatch('auth/fetchTeam');
                    }, (response) => {
                        this.error = response;
                    });
                }else{
                    axios.put('/api/people/contact-list/' + listID, this.contactList).then((response) => {
                        MicroModal.close("contact-list-modal");
                        this.$store.dispatch('auth/fetchTeam');
                    }, (response) => {
                        this.error = response;
                    });
                }
            },
            deleteContactList(listID){
                if(typeof listID !== "undefined"){
                    axios.delete('/api/people/contact-list/' + listID).then((response) => {
                        MicroModal.close("delete-list");
                        this.$store.dispatch('auth/fetchTeam');
                    }, (response) => {
                        this.error = response;
                    });
                }
            },
            confirmDeleteList(){
                MicroModal.close("contact-list-modal");
                MicroModal.show("delete-list");
            }
        }
    }
</script>